import { CaretDownFilled } from "@ant-design/icons"
import styled from "styled-components"
import { BT } from "../styles/blog-typography"

/**
 * Select field styled for blog tag selection.
 * @example
 * <SelectCaret />
 * <TagSelect
 * id={"tags"}
 * name={"tags"}
 * value={activeTab}
 * onChange={(e) => onChange(e.target.value)}>
 * ...
 * </TagSelect>
 */
const TagSelect = styled.select`
  ${BT.sm.body`400`};
  color: var(--slate);
  font-size: 16px;
  padding: 12px 16px;
  width: 100%;
  box-sizing: border-box;
  background: var(--white);
  border: 1px solid #cccccc80;
  border-radius: 2px;
  appearance: none;
  :focus,
  :active {
    outline: none;
  }
`

/**
 * Caret icon styled for blog tag selection.
 */
export const SelectCaret = styled(CaretDownFilled)`
  ${BT.sm.body`400`};
  color: var(--slate);
  right: 16px;
  top: 25%;
  position: absolute;
  pointer-events: none;
`

export default TagSelect
